import { render, staticRenderFns } from "./LastSales.vue?vue&type=template&id=447da108&scoped=true"
import script from "./LastSales.vue?vue&type=script&lang=js"
export * from "./LastSales.vue?vue&type=script&lang=js"
import style0 from "./LastSales.vue?vue&type=style&index=0&id=447da108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447da108",
  null
  
)

export default component.exports